<template>
  <div class="bgView">
    <div class="header">
      <div class="title" >选择航线</div>
      <img class="addBtn" :src="addImg" @click="addAirline"/>
     </div>
    
    <div class="projectList">
      <div v-for="(item,index) in airlineLists" :key="index">
       <!-- <div class="projectItem" :class="selectedProject == item?'selected':'normal'"
          @click="selectProject(item)">
          <div class="projectItemTitle">{{item.projectName}}</div>
          <div class="operationBox">
            <img :src="modifyImg" style="margin-right:10px" class="operationImg" @click="modifyBtnClicked(item)" />
            <img :src="deleteImg" class="operationImg" @click="deleteBtnClicked(item)" />
          </div>
         
          </div> -->
          <div class="airlineItem" :class="selectedAirline == item ? 'selected' :'normal'" 
          @click="selectAirline(item)">
          
            <div class="projectItemTitle">{{item.airlineName}}</div>
            <div class="operationBox">
              <img :src="modifyImg" style="margin-right:10px" class="operationImg" @click="modifyBtnClicked(item)" />
              <img :src="deleteImg" class="operationImg" @click="deleteBtnClicked(item)" />
            </div>
          </div>
      </div>
      <div v-if="airlineLists.length === 0" style="color:rgba(255,255,255,0.6)">暂无航线</div>
    </div>
    <div class="footer" @click="loadAirline">加载航线</div>
      
    <airline-add v-show="isShowProjectAdd" :selectedProjectId="projectId" 
    :selectedAirlineId="updateAirlineId"
     :isUpdate="isUpdate" 
     @receiveClose="receiveClose"></airline-add>
  </div>
</template>

<script>
import AirlineAdd from './AirlineAdd.vue'
export default {
  name: 'Airline',
  props:[
    "isUpdate",
    "selectedProjectId"
  ],
  data () {
    return {
      addImg:require('../assets/images/add.png'),
      modifyImg: require('../assets/images/modify.png'),
      deleteImg: require('../assets/images/delete.png'),
      airlineLists:[],
      selectedAirline:{},
      isUpdate:false,
      updateAirlineId:'',
      isShowProjectAdd:false,
      projectId:''
    }
  },
  components:{
    AirlineAdd
  },
  watch:{
    selectedProjectId(val) {
      console.log("this.props.selectedProjectId=",val);
      console.log("this = ",this);
       this.projectId = val;
    console.log("this.projectId",this.projectId)
      this.getAirlineList();
    }
  },
  mounted() {
    console.log("this.props.projectId",this.props.projectId)
     this.projectId = this.props.projectId;
    console.log("this.projectId",this.projectId)
    this.getAirlineList();
  },
  methods: {
    selectAirline(item) {
      this.selectedAirline = item;
    },
    loadAirline() {
      if (!this.selectedAirline.airlineId) {
        $alertBox.alert({
          message: "请选择一条航线加载"
        })
        return;
      }
      console.log("loadAirline");
      this.$emit("onLoadAirline",this.selectedAirline)
    },
    getAirlineList() {
      let url = baseIp + 'airline/getAirlineList'
      let param = new FormData();
      param.append("userId",localStorage.getItem('userId'));
      param.append("projectId",this.projectId);

      let config = {
        headers:{
          // 'Content-Type':'application/json; charset=utf-8',
          "token":localStorage.getItem('token')
          ,"Access-Control-Allow-Origin":'*'
        }
      };
      console.log(url);
      this.$ajax.post( url,param,config)
      .then((res)=>{
        if (res.data.code == 200) {
          this.airlineLists = res.data.data;
        
        }
        else {
            // alert(res.data.message);
            $alertBox.alert({

              message:res.data.message
            })
        } 

        // this.$set("item","selected",false);
        // this.datas.forEach(item=>{
        //   item.photo = baseIp +'student/viewPhoto/'+ item.photo;
        // })
      })
    },
     addAirline () {
      this.isUpdate = false;
      this.updateAirlineId = '';
      this.isShowProjectAdd = true;
    },
     modifyBtnClicked(item) {
      this.isUpdate = true;
      this.updateAirlineId = item.airlineId;
      console.log("this.updateAirlineId",this.updateAirlineId);
      this.isShowProjectAdd = true;
    },
    deleteBtnClicked() {
      var _this = this;
      $alertBox.alert({
        message:"确定要删除这条航线吗？",
        onConfirm() {
          _this.deleteAirline();
        }
      })
    },
    deleteAirline() {
       let url = baseIp + 'airline/deleteAirline'
      let param = new FormData();
      // param.append("userId",localStorage.getItem('userId'));
      param.append("airlineId",this.selectedAirline.airlineId);

      let config = {
        headers:{
          // 'Content-Type':'application/json; charset=utf-8',
          "token":localStorage.getItem('token')
          ,"Access-Control-Allow-Origin":'*'
        }
      };
      console.log(url);
      this.$ajax.post( url,param,config)
      .then((res)=>{
        if (res.data.code == 200) {
          this.selectedAirline = {};
          this.getAirlineList();
        
        }
        else {
            // alert(res.data.message);
            $alertBox.alert({

              message:res.data.message
            })
        } 
      })
    },
    receiveClose () {
      this.isShowProjectAdd = false;
      this.getAirlineList();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bgView {
  width:260px;
  height: 500px;
  top:60px;
  left:330px;
  position: absolute;
  background: #000000a0;
  display: flex;
  flex-direction: column;
}


.header {
  width:100%;
  height: 40px;
  position: relative;
  color: white;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #cccccc;
  background: black;
  opacity: 0.5;
}
.title {
  width:100%;
  height:100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
 
}

.addBtn {
  width:20px;
  height:20px;
  right:10px;
  position: absolute;
  cursor: pointer;
}

.projectList {
  width:100%;
  height: calc(100% - 40px);
  position: relative;
  color:white;
  /* cursor: pointer; */
}

.airlineItem {
  height: 40px;
  border-bottom: 0.5px solid #cccccc80;
  display: flex;
  align-items: center;
  position: relative;
}

.normal {
  background: transparent;
}
.selected {
  background: rgb(90, 90, 159);
  
}
.projectItemTitle {
  width:calc(100% - 70px);
  height: 100%;
  padding-left: 5px;
  position: absolute;
  text-align: left;
  display: flex;
  align-items: center;
}
.operationBox {
  width:auto;
  height: 100%;
  right:10px;
  position: absolute;
  display: flex;
  align-items: center;
}

.operationImg {
  width:20px;
  height:20px;
  position: relative;
  cursor: pointer;
}

.footer {
  width:100%;
  height: 40px;
  position: relative;
  color: white;
  cursor: pointer;
  border-top: 1px solid #cccccc;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Airline.vue